<template>
  <div
    v-outside-click="{
      'exclude': [],
      'handler': 'onLoseFocus'
    }">
    <div class="w-full mt-4">
      <label class="text-left block font-bold"> {{ label }}</label>
      <div class="grid grid-cols-6 gap-7">
        <ValidationProvider :rules="rulesBase[filteredRequired.toString()]" name="street" v-slot="{ errors }"
          class="col-span-2">
          <TextField 
            :placeholder="'Street Address'"
            v-model="formValues.street" 
            @input="setHouseNumber(); updateValue()" 
          >
          </TextField>
          <span
            class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
            name="error-text">
            {{ errors[0] }}
          </span>
        </ValidationProvider>
        <TextField
          :placeholder="'Apt./Box No.'"
          v-model="formValues.apartment"
          @input="updateValue()"
        >
        </TextField>
        <ValidationProvider :rules="rulesBase[filteredRequired.toString()]" name="city" v-slot="{ errors }">
          <TextField
            :placeholder="'City'"
            v-model="formValues.city"
            @input="updateValue()"
          >
          </TextField>
          <span
            class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
            name="error-text">
            {{ errors[0] }}
          </span>
        </ValidationProvider>
        <ValidationProvider :rules="rulesBase[filteredRequired.toString()]" name="state" v-slot="{ errors }">
          <div class="flex flex-row items-center">
            <XButton
              class="bg-gray-200 h-8 w-8 p-2 mt-2 rounded-l-md"
              v-if="showClearStateField"
              @click="clearStateField()"
            />
            <SelectionField
              class="!rounded-r-md"
              v-model="formValues.state"
              @input="updateValue()"
              :options="states"
            />
          </div>
          <span
            class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
            name="error-text">
            {{ errors[0] }}
          </span>
        </ValidationProvider>
        <ValidationProvider :rules="rulesBaseZipCode[filteredRequired.toString()]" name="zip code" v-slot="{ errors }">
          <TextField
            :placeholder="'Zip Code'"
            :mask="'#####'"
            v-model="formValues.zip_code"
            @input="updateValue()"
          >
          </TextField>
          <span
            class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
            name="error-text">
            {{ errors[0] }}
          </span>
        </ValidationProvider>
      </div>
       <!-- formValues: {{ formValues }}  -->
       <!--
      street: {{ street }}
      number: {{ houseNumber }}
      default: {{ defaultValue }} -->
    </div>
  </div>
</template>

<script>
import DropdownLists from './DropdownLists.json'
import cloneDeep from 'clone-deep'

import TextField from '../components/formComponents/TextField.vue'
import SelectionField from '../components/formComponents/SelectionField.vue'
import XButton from '../components/XButton.vue'
import { isObject, isString, isNil } from 'lodash'

export default {
  //name: "AddressValidation",
  components: {
    TextField,
    SelectionField,
    XButton,
  },
  data() {
    return {
      query: "",
      formValues: { street: '', apartment: '', city: '', state: '', zip_code: '' },
      selected: null,
      street: "",
      houseNumber: "",
      states: DropdownLists.states,
      allFilled: '',
      blurred: false,

      anySelected: false,

      rulesBase: {
        'true': 'required',
        'false': '',
      },
      rulesBaseZipCode: {
        'true': 'required|zipCodeCheck',
        'false': 'zipCodeCheck',
      },
    }
  },
  props: {
    name: String,
    label: String,
    submitFunction: Function,
    disableDefaultValueUpdates: Boolean,
    defaultValue: undefined,
    required: {
      type: Boolean,
      default: true,
    },
    showClearStateField: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    filteredRequired() {
      return this.required || this.anySelected
    }
  },
  methods: {
    zipCodeFormat() {
      return /(^\d{5}$)|(^\d{5}-\d{4}$)|(^\d{5} \d{4}$)/
    },
    updateValue() {
      this.$emit('input', this.formValues);
    },
    updateAnySelected(newValue) {
      this.anySelected =
        Boolean(newValue.street) ||
        Boolean(newValue.apartment) ||
        Boolean(newValue.city) ||
        Boolean(newValue.state) ||
        Boolean(newValue.zip_code)
    },
    clearStateField() {
      this.formValues.state = undefined
    },
    blurFunction: function (e) {
      let val = e.target.value
      if (val === '') {
        this.blurred = true
      }
    },
    addressMessage: function (e) {
      const missing = [{'Street': e.street}, {'City': e.city}, {'State': e.state}, {'Zip Code': e.zip_code}].reduce((missing, field) => {
        if (Object.values(field)[0] === '') {
          missing.push(Object.keys(field)[0])
        }
        return missing
      }, [])
      return `Please fill out valid ${missing.join(', ')} field.`
    },
    setDefaultAddress() {
      if (this.disableDefaultValueUpdates) {
        return
      }

      if (this.defaultValue && this.checkSchema(this.defaultValue)) {
        this.formValues = cloneDeep(this.defaultValue)
      }
      else {
        this.formValues = { street: '', apartment: '', city: '', state: '', zip_code: '' }
      }
      this.updateAnySelected(this.formValues)

      this.$emit('defaultValueUsed')
    },
    checkSchema(obj) {
      if (!isObject(obj)) {
        console.warn(`Invalid default value data type in StudentAddress, ${typeof obj}`)
        return false
      }

      if (!(isNil(obj.street) || isString(obj.street))) {
        console.warn(`Invalid default value data type in DistrictSelection.street, ${typeof obj.street}`)
        delete obj.street
      }
      if (!(isNil(obj.apartment) || isString(obj.apartment))) {
        console.warn(`Invalid default value data type in DistrictSelection.apartment, ${typeof obj.apartment}`)
        delete obj.apartment
      }
      if (!(isNil(obj.city) || isString(obj.city))) {
        console.warn(`Invalid default value data type in DistrictSelection.city, ${typeof obj.city}`)
        delete obj.city
      }
      if (!(isNil(obj.state) || isString(obj.state))) {
        console.warn(`Invalid default value data type in DistrictSelection.state, ${typeof obj.state}`)
        delete obj.state
      }
      if (!(isNil(obj.zip_code) || isString(obj.zip_code))) {
        console.warn(`Invalid default value data type in DistrictSelection.zip_code, ${typeof obj.zip_code}`)
        delete obj.zip_code
      }

      return true
    },
    setHouseNumber() {
      this.street = this.formValues.street
      let temp = this.street ? this.street.split(' ') : [];
      this.houseNumber = temp.shift();
    },
    onLoseFocus() {
      this.$emit('loseFocus')
    }
  },
  async mounted() {
    this.setDefaultAddress()
    await this.$nextTick()
    this.setHouseNumber()
  },
  updated() {
    this.allFilled = this.formValues.street && this.formValues.city && this.formValues.state && this.formValues.zip_code;
  },
  watch: {
    defaultValue() {
      this.setDefaultAddress()
      this.updateValue()
    },
    formValues: {
      deep: true,
      handler: function (newValue) {
        this.updateAnySelected(newValue)
      }
    },
  }
}
</script>

<style>
.form-control:not(textarea)  {
  height: calc(2.1em + 0.5rem + 2px) !important;
}

.d-center {
  display: flex;
  align-items: center;
}

.v-select .dropdown li {
  border-bottom: 1px solid rgba(112, 128, 144, 0.1);
}

.v-select .dropdown li:last-child {
  border-bottom: none;
}

.v-select .dropdown li a {
  padding: 10px 20px;
  width: 100%;
  font-size: 1.25em;
  color: #3c3c3c;
}

.v-select .dropdown-menu .active > a {
  color: #fff;
}
</style>
